let owners = 0;
let originalOverflow;
export function lockScheduleScroll() {
    if (owners++ === 0) { originalOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
    return () => { if (--owners === 0) document.body.style.overflow = originalOverflow; };
}
